<template>
    <v-dialog v-model="showModal">
        <v-card style="height: 85dvh">
            <div>
                <CreativeEditor @onSave="onEditorSave" @close="showModal = false" ref="imglyEditor" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import TributePhotoService from '@/services/tributePhoto.service';
import BlobService from '../../../services/blob.service';
import { mapActions } from 'pinia';
import { useTributeVideoStore } from '@/stores/tributeVideo';
import { useGlobalState } from '@/stores/globalState';
export default {
    name: 'PhotoEditorModal',
    setup() {
        return {
            tributeVideoStore: useTributeVideoStore(),
        }
    },
    props: {
        mainPhotoId: {
            type: Number,
            required: true,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
        eventId: {
            type: Number,
            required: true,
        },
        token: {
            type: String,
            required: true,
        },
    },
    components: {
        CreativeEditor: () => import('@/components/Tribute/Editor/CreativeEditor'),
    },
    data() {
        return {
            api: null,
            showModal: false,
            editingPhoto: null,
            photo: null,
        };
    },
    computed: {
        imglyConfig() {
            return {
                theme: 'light',
                mobile: this.isMobile,
                // layout: this.state.isMobile ? 'basic': 'advanced',
                // layout: 'advanced',
                // layout: 'basic',
                license: '{"owner":"Imgly Inc.","version":"2.4"}',
            };
        },
    },
    methods: {
        ...mapActions(useGlobalState, ['showSnackbar']),
        initApiService() {
            if (this.$props.token && !this.api) {
                this.api = TributePhotoService(this.$props.token);
            }
        },
        async open() {
            this.initApiService();
            this.showModal = true;
            if (!this.$props.mainPhotoId) {
                return;
            }
            const { data } = await this.api.getPhotoById(this.$props.mainPhotoId);
            if (data.id === this.$props.mainPhotoId) {
                this.photo = data;
                await this.$nextTick();
                this.$refs.imglyEditor.createSceneFromURL(data.url, data.id, data.mediaType);
            }
        },
        close() {
            this.showModal = false;
        },
        async performMediaUpdate(eventId, file) {
            let { data: SAS_INFO } = await this.api.getUploadUrl(eventId, file);

            // TODO: add cancel token
            await BlobService.upload(SAS_INFO.sas, file, {
                onUploadProgress: progressEvent => {
                    this.tributeVideoStore.updateProfileUploadProgress(Math.ceil((progressEvent.loaded / progressEvent.total) * 100));
                },
            });
            return { SAS_INFO };
        },
        async onEditorSave(editorResults) {
            this.close();
            const { blob } = editorResults;
            // Are we editing an existing slide or is this a new one?
            blob.name = this.photo.name;
            this.tributeVideoStore.updateShowProfileUploadProgress(true);
            this.showUploadProgress = true;
            const { SAS_INFO } = await this.performMediaUpdate(this.$props.eventId, blob);
            const { data: updatedPhoto } = await this.api.replacePhoto(this.photo.id, SAS_INFO.fileName, true);
            this.photo = updatedPhoto;
            this.tributeVideoStore.updateTributeVideo({
                mainPhotoId: updatedPhoto.id,
                mainPhotoUrl: updatedPhoto.url,
            });
            this.tributeVideoStore.updateShowProfileUploadProgress(false);
        },
        async deleteProfilePhoto() {
            const photoId = this.$props.mainPhotoId;

            if (!photoId) {
                this.showSnackbar({ message: 'Error deleting profile photo', color: 'error' });
                return;
            }

            this.tributeVideoStore.updateTributeVideo({
                mainPhotoId: 0,
                mainPhotoUrl: null,
            });

            try {
                await this.api.deletePhoto(photoId);
                this.showSnackbar({ message: 'Profile picture deleted' });
                this.close();
            } catch (error) {
                console.log(error, 'error deleting profile photo');
            }
        },
        revertPhoto(photo) {
            if (photo.originalPhoto == null) {
                this.showSnackbar({ message: 'No photo to revert to' });
                return;
            }

            this.api.revertPhotoToOriginal(photo.id).then(resp => {
                this.tributeVideoStore.updateTributeVideo({
                    mainPhotoId: resp.data.id,
                    mainPhotoUrl: resp.data.url,
                });
                this.showSnackbar({ message: 'Original photo restored' });
                this.close();
                this.editingPhoto = null;
            });
        },
    },
    mounted() {
        this.initApiService();
    },
};
</script>
<style lang="scss" scoped>
.image-error-div {
    min-height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    inset: 0;
}
</style>
